import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      /// Verifica se a sessionStorage é suportada pelo navegador
      if (typeof (Storage) !== "undefined") {

        let url = window.location.href;
        let domain = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/img)

        let value = sessionStorage.getItem(`cart-preview-cache-${domain}`);
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          if (value !== null) {
            let ObjectValue = JSON.parse(value);
            let htmlItens = ObjectValue.html_itens
            let itensCartPreview = document.querySelector('.items_cart_preview');
            itensCartPreview.innerHTML = htmlItens
          } else {
            console.log("Não há valor armazenado para a chave fornecida.");
          }
        }

      } else {
        console.log("Desculpe, seu navegador não suporta sessionStorage.");
      }
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var $el = $(el);
    
      if ($el.visible(true)) {
        $el.addClass("widget-loaded");
    
        // Dispara o mouseenter se ainda precisar para outros efeitos
        $el.children().trigger("mouseenter");
    
        // Troca data-src por src nas imagens dentro de .product-item__content--figure
        $el.find(".product-item__content--figure img").each(function () {
          var $img = $(this);
          var dataSrc = $img.attr("data-src");
    
          if (dataSrc) {
            $img.attr("src", dataSrc).removeAttr("data-src");
          }
        });
      }
    });
  }

  // Adicionar mais eventos para melhor compatibilidade mobile
  $(window).on('scroll mousemove touchstart touchmove touchend', function () {
    loadWidgets();
  });
  
  // Adicionar evento específico para quando a página terminar de carregar
  $(document).ready(function() {
    loadWidgets();
  });

  // const comunicado = document.querySelector('.comunicado');
  // if (comunicado) {
  //   $('#carrousel-comunicado').slick({
  //     arrows: false,
  //     dots: true,
  //     infinite: false,
  //     autoplay: true,
  //     mobileFirst: true,
  //     slidesToShow: 2,
  //     slidesToScroll: 2,
  //     speed: 2000,
  //     responsive: [
  //       {
  //         breakpoint: 991,
  //         settings: "unslick"
  //       },
  //     ]
  //   });
  // }

  const aboutThemes = document.querySelector('.about-themes');
  if (aboutThemes) {
    $('#carrousel-second-section').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

});

const pageExtraCarrosel = document.querySelector('#dynamic-page-extra .image-list');
if (pageExtraCarrosel) {
  $('#dynamic-page-extra .image-list').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
}